import { render, staticRenderFns } from "./DeliveryPayment.vue?vue&type=template&id=3769c2de&"
import script from "./DeliveryPayment.vue?vue&type=script&lang=js&"
export * from "./DeliveryPayment.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryPayment.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports